import React from 'react';
import GeckoTableCellBase from '../_base.jsx';
import { GECKO_CONSTS, GECKO_UTILS, GeckoDropdown } from '../../../../../';

class GeckoTableCellDropdown extends GeckoTableCellBase {
  renderId() {
    if (!this.dropdownId) this.dropdownId = GECKO_UTILS.generateUniqueId();
    return `gecko-table-cell-${this.dropdownId}`;
  }
  areAllItemsHidden() {
    return this.props.col.items.every(item => item.hideWhen? item.hideWhen(this.props.row) : false)
  };

  render() {
    return (
      <div
        className={this.renderId()}
        onClick={(event) => event.stopPropagation()}
      >
        <GeckoDropdown
          preset={GECKO_CONSTS.BTN_PRESET_ACTIONS_COMPACT}
          items={this.props.col.items}
          bind={this.props.row}
          index={this.props.index}
          align="right"
          buttonConfig={{disabledWhen:() => this.areAllItemsHidden()}}
        />
      </div>
    );
  }
}

export default GeckoTableCellDropdown;
